export enum TourType {
  ACTIVITY = 1,
  LEXICON = 2,
  CONTACT = 3,
  TEMPLATES = 4,
  PROFILE = 5
}

